/* eslint-disable @typescript-eslint/no-unused-vars */

import {LocalFileService} from '../local-file.service';
import {Vault} from '../../../api/models/vault';
import {Injectable, inject} from '@angular/core';
import {downloadBlob} from '../../../util/download-blob.util';
import {ClipboardService} from '../../clipboard/clipboard.service';

@Injectable()
export class ElectronMacLocalFileService implements LocalFileService {
    private readonly clipboardService = inject(ClipboardService);

    public async createVaultDirectory(vault: Vault): Promise<void> {
    }

    public async shareFile(content: ArrayBuffer, filename: string): Promise<void> {
        // share menu erstmal deaktviert -> bisher auch nur ein download - siehe electron-local-file-service.ts
        return this.saveFile(content, filename);
    }

    public async saveFile(content: ArrayBuffer, filename: string, openFile: boolean = false): Promise<void> {
        const blob = new Blob([content], { type: 'application/octet-stream' });
        await new Promise(r => window.setTimeout(r, 1000)); // Timeout is needed for iOS Safari bug, which blocks all calls when the download of the file is running
        downloadBlob(blob, filename);
    }

    public async shareUrl(url: string): Promise<void> {
        await this.clipboardService.copyToClipboard(url);
    }
}
